import React, {useEffect, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {
  changeHandlerNew,
  editPhone,
  setPhone,
  onCheck,
  onUncheck,
  termsMsg,
  clearValid,
  reportAnalytics,
} from '../../SaleBlock/AlmostDone/AlmostDoneSlice';
import {connect} from 'react-redux';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import TextInput from '../../../Shared/TextInput/TextInput';
import Lottie from 'react-lottie';
import ThumbsUpAnimation from '../../../../animations/like-thumb-up-outline.json';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {prepareUrl} from '../../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import Image from 'app/Components/Shared/Image/image';
import ThemedLottie from '../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../utilities/theme/ThemeColorEnum';

const StandAloneSaleAlmostDone = (props) => {
  const [showTermsOfUse, setTermsOfUse] = useState(false);
  const isDeliveryFree =
    props.deliveryCost === '' ||
    props.deliveryCost === '0' ||
    parseInt(props.productQuantity) >= parseInt(props.minQuantityForFreeDelivery);
  const isProductFree = props.productPrice === '0' || props.productPrice === '';

  useEffect(() => {
    if (props.isSubmit) {
      props.termsMsg(!props.isTermsAccepted);
      if (!props.isTermsAccepted || (props.isOtpPhoneEdit && !props.form.valid)) {
        props.onValid(false);
      } else {
        props.clearValid();
        props.onValid(true);
      }
    }
  }, [props.isSubmit]);

  const phoneComponent = () => {
    return (
      <div className='phone-edit'>
        {`טלפון עבור השליח: ${props.otpPhone}`}
        <span onClick={() => props.editPhone(props.otpPhone)}>ערוך</span>
        {props.isOtpPhoneEdit ? (
          <div className='phoneInput'>
            <TextInput
              name='phone'
              type='tel'
              autoComplete='off'
              placeholder='מספר טלפון'
              maxLength='10'
              value={props.form.phone}
              error={props.form.errors.phone}
              onChange={(e) => props.changeHandlerNew({value: e.target.value})}
            />
          </div>
        ) : null}
      </div>
    );
  };
  return (
    <Container className='stand-alone-sale-almost-done'>
      <div className='stand-alone-sale-almost-done_img'>
        {/* <Lottie options={{animationData: ThumbsUpAnimation, loop: false}} width={200} height={200} /> */}
        <ThemedLottie animationData={ThumbsUpAnimation} color={ThemeColorEnum.PRIMARY} width={200} height={200} loop={false} />
      </div>
      <Row>
        <Col>
          <section className='whatWeHave'>
            <p className='whatWeHave__title'>אז מה היה לנו?</p>
            <Row>
              <Col>
                <div className='product'>
                  <span className='product__name'>
                    {props.productQuantity} x {props.productToPurchaseTitle}
                  </span>
                  <span className='product__price'>
                    {isProductFree ? 'ללא עלות' : `₪${parseInt(props.productPrice) * parseInt(props.productQuantity)}`}
                  </span>
                </div>
                <div className='product'>
                  <span className='product__name'>שליחות</span>
                  <span className='product__price'>
                    <div>{`${isDeliveryFree ? 'ללא עלות' : `₪${props.deliveryCost}`}`}</div>
                  </span>
                </div>
                <hr />
                <div className='product'>
                  <span className='product__name'>סה"כ</span>
                  <span className='product__price'>
                    <div>{`${
                      isDeliveryFree && isProductFree
                        ? 'ללא עלות'
                        : `₪${
                            (isProductFree ? 0 : parseInt(props.productPrice) * parseInt(props.productQuantity)) +
                            (isDeliveryFree ? 0 : parseInt(props.deliveryCost))
                          }`
                    }`}</div>
                  </span>
                  {!(isDeliveryFree && isProductFree) && <span className='product__side-note'>חד פעמי</span>}
                </div>
              </Col>
            </Row>
          </section>
        </Col>
      </Row>
      <Row>
        <Col>
          <section className='details'>
            <p className='details__title'>מי יפגוש את השליח?</p>
            <div className='details__text'>
              <span>{`${props.firstName} ${props.lastName}`}</span>
              <span>{props.fullAddress}</span>
              {phoneComponent()}
            </div>
          </section>
        </Col>
      </Row>
      <Row>
        <Col xs='12' md='12'>
          <p className='adult-note'>חשוב שתהיה מעל גיל 18</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <section className='details'>
            <Row>
              <Col>
                <p className='details__title'>איך נשלם?</p>
                <div className='details__text' style={{direction: 'rtl'}}>
                  {`החיוב יתווסף לחשבונית החודשית המשולמת באמצעי תשלום שמסתיים ב: ${props.paymentToken?.trim().slice(-4)}`}
                </div>
              </Col>
            </Row>
            <Row className='termOfService'>
              <Col xs='2' md='1' className='termOfService__checkbox'>
                <div>
                  <CheckBox
                    id='approveTerms'
                    onCheck={(e) => props.onCheck()}
                    onUncheck={() => {
                      props.onUncheck();
                    }}></CheckBox>
                </div>
              </Col>
              <Col xs='10' md='10'>
                <p className='termOfService__link'>
                  {` `}קראתי ואישרתי את
                  <span className='termOfService__link__url' onClick={() => setTermsOfUse(true)}>
                    {` תנאי העסקה`}
                  </span>
                </p>
              </Col>
              {props.isTermsMsg && <div className='terms-error'>חובה לאשר את תקנון השרות</div>}
            </Row>
          </section>
        </Col>
      </Row>
      <Row>
        <hr style={{width: '100%', borderTop: '.4rem solid #f6f7f7'}} />
      </Row>
      <div className='terms_of_use_popup '>
        <PopUp showPopUp={showTermsOfUse} onClose={() => setTermsOfUse(false)}>
          <>
            <div className='terms-popup-title'>תנאי התוכנית</div>
            <div className='terms-popup'>
              <div className='terms_item'>
                <div className='terms_link_item' onClick={() => prepareUrl(props.checkoutPageTransactionTermsLink, EpiContext)}>
                  <Image src={require('./images/payment-icons-attach.svg')} alt='להורדה' className='terms_icon_attach'/>
                  {props.productToPurchaseTitle}
                </div>
              </div>
            </div>
          </>
          <BtnSubmit text='חזור לתהליך' onclick={() => setTermsOfUse(false)} />
        </PopUp>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.almostDone?.form,
    isOtpPhoneEdit: state.almostDone?.phoneIsEdit,
    isTermsMsg: state.almostDone?.isTermsMsg,
    isTermsAccepted: state.almostDone?.isTermsAccepted,

    //stand alone purchase block slice
    minQuantityForFreeDelivery:
      state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productMinQuantityForCancellingDeliveryCost.value ?? '',
    productToPurchaseTitle: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchaseTitle.value ?? '',
    checkoutPageTransactionTermsLink: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.checkoutPageTransactionTermsLink.value ?? '',
    productPrice: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchasePrice?.value ?? '',
    productQuantity: state.standAlonePurchaseSaleBlock?.productQuantity,
    deliveryCost: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.deliveryCost.value ?? '',
    paymentToken: state.standAlonePurchaseSaleBlock?.tvProducts.filter((prd) => prd.chosenSubscription === true)[0].paymentToken ?? '',
    otpPhone: state.standAlonePurchaseSaleBlock?.form?.phone ?? '',
    fullAddress: `${state.standAlonePurchaseSaleBlock?.form?.streetName} ${state.standAlonePurchaseSaleBlock?.form?.home}, ${state.standAlonePurchaseSaleBlock?.form?.cityName}`,

    //other states
    firstName: state.authentication?.loginData?.userDetails?.firstName ?? '',
    lastName: state.authentication?.loginData?.userDetails?.lastName ?? '',
  };
};

const mapDispatchToProps = {changeHandlerNew, editPhone, setPhone, onCheck, onUncheck, termsMsg, clearValid, reportAnalytics};

export default connect(mapStateToProps, mapDispatchToProps)(StandAloneSaleAlmostDone);
